import {Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';
import {type DRILLDOWN_STATES} from 'web-app/react/child-development/child-development-drilldown-switcher/constants';

import * as Actions from './actions';

export interface ChildDevelopmentDrilldownModalProps {
    readonly isVisible: boolean;
    readonly childId?: string;
    readonly refetchQueries?: any;
    readonly subAreaId?: string;
    readonly ageBandId?: string;
    readonly mode?: DRILLDOWN_STATES;
    readonly disallowLinks?: boolean;
}
export class ChildDevelopmentDrilldownModal extends Record<ChildDevelopmentDrilldownModalProps>({
    isVisible: false,
    childId: undefined,
    refetchQueries: undefined,
    subAreaId: undefined,
    ageBandId: undefined,
    mode: undefined,
    disallowLinks: undefined,
}) {}

export default makeReducer<ChildDevelopmentDrilldownModal>(
    [
        match(
            Actions.show,
            (state, {payload}) =>
                new ChildDevelopmentDrilldownModal({
                    isVisible: true,
                    childId: payload.childId,
                    refetchQueries: payload.refetchQueries,
                    subAreaId: payload.subAreaId,
                    ageBandId: payload.ageBandId,
                    mode: payload.mode,
                    disallowLinks: payload.disallowLinks,
                }),
        ),
        match(Actions.hide, state =>
            state.merge({
                isVisible: false,
            }),
        ),
    ],
    new ChildDevelopmentDrilldownModal(),
);
